// @flow
import styles from './SearchResult.css'

export const getStatusClassName = (status = '') => {
  switch (status.toLowerCase()) {
    case 'approved':
    case 'active':
      return styles.statusActive
    case 'closed':
      return styles.statusClosed
    case 'closing':
    case 'pending':
    case 'suspended':
      return styles.statusClosing
    default:
      return styles.statusDefault
  }
}

const getStatusSortRank = (status) => {
  if (status == null || status === '') return 3
  switch (String(status).toLowerCase()) {
    case 'approved':
    case 'active':
      return 0
    case 'closing':
    case 'pending':
    case 'suspended':
      return 1
    case 'closed':
      return 2
    default:
      return 3
  }
}

const compareAccountNumbers = (firstAccountNumber, secondAccountNumber) => {
  if (firstAccountNumber == null && secondAccountNumber == null) return 0
  if (firstAccountNumber == null) return 1
  if (secondAccountNumber == null) return -1
  const firstTrimmed = String(firstAccountNumber).trim()
  const secondTrimmed = String(secondAccountNumber).trim()
  const firstAsNumber = Number(firstTrimmed)
  const secondAsNumber = Number(secondTrimmed)
  const bothAreNumericAccountIds =
    firstTrimmed !== '' &&
    secondTrimmed !== '' &&
    Number.isFinite(firstAsNumber) &&
    Number.isFinite(secondAsNumber)
  if (bothAreNumericAccountIds) return firstAsNumber - secondAsNumber
  return firstTrimmed.localeCompare(secondTrimmed, undefined, { numeric: true })
}

export const sortMergedBeneficiaries = (firstRow, secondRow) => {
  const statusComparison =
    getStatusSortRank(firstRow.status) - getStatusSortRank(secondRow.status)
  if (statusComparison !== 0) return statusComparison
  return compareAccountNumbers(firstRow.number, secondRow.number)
}
